import { Button } from "@/components/ui/button";
import { Trash } from "@phosphor-icons/react";

/**
 * Tab body: "Campaigns" — one row per registered Shopnomix campaign
 * credential. Actions Test / Sync / +Pub / Delete are wired to
 * orchestrator handlers; the Delete button is disabled when the
 * campaign still has assigned publishers (force the admin to revoke
 * pubs first so we never orphan their tracker URLs).
 */
export default function CampaignsTab({
  campaigns, loading, syncingId, onTest, onSync, onOpenAssign, onDelete,
}) {
  return (
    <div className="border border-slate-200 rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50">
          <tr className="border-b border-slate-200">
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Label</th>
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Campaign ID</th>
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Token</th>
            <th className="text-center px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Status</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Pubs</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Last sync</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Actions</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((c) => (
            <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="px-4 py-3 font-medium text-slate-900">{c.label}</td>
              <td className="px-4 py-3 font-mono text-xs text-slate-600">{c.campaign_id}</td>
              <td className="px-4 py-3 font-mono text-xs text-slate-400">…{c.reporting_token_last4}</td>
              <td className="px-4 py-3 text-center">
                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                  c.status === "active" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"
                }`}>{c.status}</span>
              </td>
              <td className="px-4 py-3 text-right font-mono text-slate-700">{c.assigned_publisher_count || 0}</td>
              <td className="px-4 py-3 text-right text-xs text-slate-500">
                {c.last_sync_at ? new Date(c.last_sync_at).toLocaleString() : "—"}
              </td>
              <td className="px-4 py-3 text-right">
                <div className="flex justify-end gap-1">
                  <Button size="sm" variant="ghost" onClick={() => onTest(c)} data-testid={`sn-test-${c.id}`}>Test</Button>
                  <Button size="sm" variant="ghost" onClick={() => onSync(c.id)} disabled={syncingId === c.id} data-testid={`sn-sync-${c.id}`}>
                    {syncingId === c.id ? "…" : "Sync"}
                  </Button>
                  <Button size="sm" variant="ghost" onClick={() => onOpenAssign(c)} data-testid={`sn-assign-${c.id}`}>
                    + Pub
                  </Button>
                  <Button size="sm" variant="ghost" className="text-rose-600 hover:bg-rose-50" onClick={() => onDelete(c)} disabled={(c.assigned_publisher_count || 0) > 0} data-testid={`sn-delete-${c.id}`}>
                    <Trash size={14} />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
          {campaigns.length === 0 && !loading && (
            <tr><td colSpan={7} className="px-4 py-6 text-center text-sm text-slate-400">No campaigns yet — click "New campaign".</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
